/**
 * Schema of Motorista
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {
  $,
  RenderImage,
  rg,
  cpf,
  date,
  datetime,
  phone,
} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import RenderMotoristaUrlImagem from '@/components/render/motorista/RenderMotoristaUrlImagem.vue'
import RenderData from '@/components/render/RenderData.vue'
import * as Helper from '@/helpers'
import { getResponsavel } from '@/helpers'

export default (model: Motorista): Schema => ({
  idMotoristaPk: {
    content: model.idMotoristaPk,
    editable: false,
  },

  nome: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nome'),
          value: model.nome || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: model.nome || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: model.nome || $.t('app.notInformed'),
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  cpf: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('cpf'),
          value: cpf(model.cpf) || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: cpf(model.cpf) || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: cpf(model.cpf) || $.t('app.notInformed'),
    input: InputType.CPF,
    meta: {
      required: true,
    },
  },

  rg: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('rg'),
          value: model.rg || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: model.rg || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: model.rg || $.t('app.notInformed'),
    input: InputType.MASK,
    meta: {
      required: false,
      maxlength: '15',
      mask: $.t('format.rgNoFormat'),
    },
  },

  endereco: {
    content: model.endereco && model.endereco.logradouroCidadeUf() || '',
    textContent: model.endereco && model.endereco.logradouroCidadeUf() || '',
    input: InputType.SELECT,
    meta: {
      required: false,
    },
  },

  celular: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('phone'),
          value: phone(model.celular) || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: phone(model.celular) || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: phone(model.celular) || $.t('app.notInformed'),
    input: InputType.PHONE,
    meta: {
      required: true,
    },
  },

  dataNascimento: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('dataNascimento'),
          value: datetime(model.dataNascimento) || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: datetime(model.dataNascimento) || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: date(model.dataNascimento) || $.t('app.notInformed'),
    input: InputType.DATE,
    meta: {
      required: true,
    },
  },

  email: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('email'),
          value: model.email || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.email || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.email || $.t('app.notInformed'),
    input: InputType.EMAIL,
    meta: {
      required: true,
    },
  },

  placaVeiculo: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('placaVeiculo'),
          value: model.placaVeiculo || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.placaVeiculo || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.placaVeiculo || $.t('app.notInformed'),
    input: InputType.MASK,
    meta: {
      required: true,
      maxlength: '255',
      mask: 'AAA-#X##',
      masked: true,
      tokens: {
        '#': {pattern: /\d/},
        'X': {pattern: /[0-9a-zA-Z]/, transform: (v: string) => v.toLocaleUpperCase()},
        'A': {pattern: /[a-zA-Z]/, transform: (v: string) => v.toLocaleUpperCase()},
      },
    },
  },

  senha: {
    content: model.senha,
    textContent: null,
    hidden: true,
    input: InputType.PASSWORD,
  },

  codigoSms: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('codigoSms'),
          value: model.codigoSms || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.codigoSms || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  telefoneFixo: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('telefoneFixo'),
          value: model.telefoneFixo || $.t('app.notInformed'),
        },
      },
      {
        component: RenderData,
        props: {
          value: model.telefoneFixo || $.t('app.notInformed'),
          innerClass: 'inline-word',
        },
      },
    ],
    textContent: null,
    input: InputType.PHONE,
    meta: {
      maxlength: '255',
    },
  },

  marcaVeiculo: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('marcaVeiculo'),
          value: model.marcaVeiculo || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.marcaVeiculo || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.marcaVeiculo || $.t('app.notInformed'),
    input: InputType.SELECT,
    model: 'marcaVeiculoResource',
    meta: {
      required: true,
    },
  },

  tipoVeiculo: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('tipoVeiculo'),
          value: model.tipoVeiculo || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.tipoVeiculo || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.tipoVeiculo || $.t('app.notInformed'),
    input: InputType.SELECT,
    model: 'tipoVeiculoResource',
    meta: {
      required: true,
    },
  },

  tipoCarreta: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('tipoCarreta'),
          value: model.tipoCarreta || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.tipoCarreta || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.SELECT,
  },

  tipoCarroceria: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('tipoCarroceria'),
          value: model.tipoCarroceria || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.tipoCarroceria || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.tipoCarroceria || $.t('app.notInformed'),
    input: InputType.SELECT,
    model: 'tipoCarroceriaResource',
  },

  placaCarroceira: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('placaCarroceira'),
          value: model.placaCarroceira || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.placaCarroceira || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.MASK,
    meta: {
      maxlength: '255',
      mask: 'AAA-#X##',
      masked: true,
      tokens: {
        '#': {pattern: /\d/},
        'X': {pattern: /[0-9a-zA-Z]/, transform: (v: string) => v.toLocaleUpperCase()},
        'A': {pattern: /[a-zA-Z]/, transform: (v: string) => v.toLocaleUpperCase()},
      },
    },
  },

  antt: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('antt'),
          value: model.antt || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.antt || $.t('app.notInformed'),
        },
      },
    ],
    textContent: model.antt || $.t('app.notInformed'),
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

    horaFim: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horaFim'),
                    value: model.jornadaMotorista.horaFim || $.t('app.notInformed'),
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    value: model.jornadaMotorista.horaFim.toString() || $.t('app.notInformed'),
                },
            },
        ],
        textContent: model.jornadaMotorista.horaFim.toString() || $.t('app.notInformed'),
        input: InputType.TEXT,
        meta: {
            maxlength: '255',
        },
        hidden: !getResponsavel().permitirRoterizacao,
    },

    horaInicio: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('horaInicio'),
                    value: model.jornadaMotorista.horaInicio || $.t('app.notInformed'),
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    value: model.jornadaMotorista.horaInicio.toString() || $.t('app.notInformed'),
                },
            },
        ],
        textContent: model.jornadaMotorista.horaInicio.toString() || $.t('app.notInformed'),
        input: InputType.TEXT,
        meta: {
            maxlength: '255',
        },
        hidden: !getResponsavel().permitirRoterizacao,
    },

    rangeCepInicial: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('rangeCepInicial'),
                    value: model.jornadaMotorista.rangeCepInicial || $.t('app.notInformed'),
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    value: model.jornadaMotorista.rangeCepInicial || $.t('app.notInformed'),
                },
            },
        ],
        textContent: model.jornadaMotorista.rangeCepInicial || $.t('app.notInformed'),
        input: InputType.TEXT,
        meta: {
            maxlength: '255',
        },
        hidden: !getResponsavel().permitirRoterizacao,
    },

    rangeCepFinal: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('rangeCepFinal'),
                    value: model.jornadaMotorista.rangeCepFinal || $.t('app.notInformed'),
                },
            },
            {
                component: RenderLabelValue,
                props: {
                    value: model.jornadaMotorista.rangeCepFinal || $.t('app.notInformed'),
                },
            },
        ],
        textContent: model.jornadaMotorista.rangeCepFinal || $.t('app.notInformed'),
        input: InputType.TEXT,
        meta: {
            maxlength: '255',
        },
        hidden: !getResponsavel().permitirRoterizacao,
    },

  rntrc: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('rntrc'),
          value: model.rntrc || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.rntrc || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  cnh: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('cnh'),
          value: model.cnh || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.cnh || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  urlImagem: {
    content: {
      component: RenderMotoristaUrlImagem,
      props: {
        src: model.urlImagem,
        alt: model.$tag,
      },
    },
    textContent: null,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  nomeIndicador: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nomeIndicador'),
          value: model.nomeIndicador || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: model.nomeIndicador || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  transbordoEntrega: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('transbordoEntrega'),
          value: Helper.bool(model.transbordo.podeEntregar) || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: Helper.bool(model.transbordo.podeEntregar) || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.CHECKBOX,
  },

  transbordoRecebimento: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('transbordoRecebimento'),
          value: Helper.bool(model.transbordo.podeReceber) || $.t('app.notInformed'),
        },
      },
      {
        component: RenderLabelValue,
        props: {
          value: Helper.bool(model.transbordo.podeReceber) || $.t('app.notInformed'),
        },
      },
    ],
    textContent: null,
    input: InputType.CHECKBOX,
  },
    dataCadastroEntregador: {
        content: [
            {
                component: RenderLabelValue,
                props: {
                    label: model.translateColumn('dataCadastroEntregador'),
                    value: datetime(model.dataCriacao) || $.t('app.notInformed'),
                },
            },
            {
                component: RenderData,
                props: {
                    value: datetime(model.dataCriacao) || $.t('app.notInformed'),
                    innerClass: 'inline-word',
                },
            },
        ],
        textContent: date(model.dataCriacao) || $.t('app.notInformed'),

    },
  ativo: {
    hidden: true,
    component: RenderData,
    props: {
        value: Helper.bool(model.jornadaMotorista.ativo),
    },
  },

  versao: {
    component: RenderData,
    content: model.versao || $.t('app.notInformed'),
  },

  marcaAparelho: {
    component: RenderData,
    content: model.tokenPush && model.tokenPush.marcaAparelho
      ? model.tokenPush.marcaAparelho
      : $.t('app.notInformed'),
  },

  modeloAparelho: {
    component: RenderData,
    content: model.tokenPush &&  model.tokenPush.modeloAparelho
      ? model.tokenPush.modeloAparelho
      : $.t('app.notInformed'),
  },
})
